export default function ConfirmDeleteModal({ show, title, message, onCancel, onConfirm, confirmBtnMsg = "Delete" }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2">
      <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
        <h1 className="text-lg mb-8">{title || "Confirm Delete"}</h1>
        <p className="mb-6 text-gray-700">{message || "Are you sure you want to delete it?"}</p>

        <div className="flex justify-end gap-2">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            {confirmBtnMsg}
          </button>
        </div>
      </div>
    </div>
  );
}
